import { asyncLoad } from '@util'

export default {
  path: 'creativeCenter',
  indexRoute: {
    component: asyncLoad(() =>
      import('@components/LocalMerchant/CreativeCenter')
    )
  },
  stat: '创意中心/首页',
  childRoutes: [
    {
      path: 'add',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/CreativeCenter/UpdateCreative')
      ),
      stat: '创意中心/新增创意'
    },
    {
      path: 'copy(/:id)',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/CreativeCenter/UpdateCreative')
      ),
      stat: '创意中心/复制创意'
    },
    {
      path: 'edit(/:id)',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/CreativeCenter/UpdateCreative')
      ),
      stat: '创意中心/编辑创意'
    },

    {
      path: 'dashBoard',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/CreativeCenter/CreativeDashBoard')
      ),
      stat: '创意中心/创意数据'
    }
  ]
}
